import MessageOption from 'owa-message-option/lib/MessageOption';
import { OptionSubCategory } from 'owa-options-core';
import MarkAsReadOption from 'owa-mark-as-read-option/lib/MarkAsReadOption';
import ReadReceiptsOption from 'owa-read-receipts-option/lib/ReadReceiptsOption';
import InlineTranslationOption from 'owa-inline-translation-option/lib/InlineTranslationOption';

let handlingSubCategory: OptionSubCategory = {
    key: 'handling',
    titleStringKey: 'optionSubcategory_handling',
    options: [MessageOption, MarkAsReadOption, ReadReceiptsOption, InlineTranslationOption],
};

export default handlingSubCategory;
